import { render, staticRenderFns } from "./ListadoProductos.vue?vue&type=template&id=2228ca16&"
import script from "./ListadoProductos.vue?vue&type=script&lang=js&"
export * from "./ListadoProductos.vue?vue&type=script&lang=js&"
import style0 from "./ListadoProductos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports